import { Geocoder } from "@maptiler/geocoder";

const geocoder = new Geocoder({
  key: process.env.REACT_APP_MAPTILER_API_KEY,
});

const decodeCoordinates = async ([lat, lon]) => {
  return await geocoder.geocode(`${lon},${lat}`);
};

export { decodeCoordinates };
